// Search panel for the Usage Metrics drill-down grid. The coded fields are selects (CLAUDE.md rule 3);
// their options are loaded in the screen's onFormLoad from the shared lookups in const/Lookup.js. They set
// searchEnabled: false so they are pick-only - Fields.js otherwise defaults a SelectBox to typeable.
const searchFields = [
    { name: "Bucket", type: "select", searchEnabled: false, showClearButton: true, label: "Result" },
    { name: "Verdict", type: "select", searchEnabled: false, showClearButton: true, label: "Verdict" },
    { name: "Flag", type: "select", searchEnabled: false, showClearButton: true, label: "Signal" },
    { name: "Topic", type: "select", searchEnabled: false, showClearButton: true, label: "Topic" },
    { name: "UserName", type: "text", label: "User" },
    { name: "Prompt", type: "text", label: "Prompt contains" },
];

// Four columns, filled in field order: Result, Verdict, Signal and Topic across the first row, then User and
// Prompt contains under the first two.
const GROUP_COUNT = 4;
const UsageTurnsSearchLayout = Array.from({ length: GROUP_COUNT }, (_, i) => ({
    groupId: i + 1,
    label: "",
    fields: []
}));

searchFields.forEach((field, index) => {
    const groupIndex = index % GROUP_COUNT;

    UsageTurnsSearchLayout[groupIndex].fields.push({
        ...field,
        key: `${field.name}_${index}`,
        tableName: "",
        options: field.options ?? null,
        apiUrl: field.apiUrl ?? null,
        grid: null,
        required: false,
        visible: field.visible ?? true
    });
});

export default UsageTurnsSearchLayout;
